function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
const getSize = number => `${number}px`;
const getStrokeWidth = size => {
  if (size >= 32) {
    return 2;
  }
  if (size >= 24) {
    return 1.5;
  }
  return 1.5;
};
const StyledSvg = _ref => {
  let {
      className,
      color,
      viewBox,
      dataTest,
      children,
      ariaHidden,
      ariaLabel
    } = _ref,
    props = _objectWithoutProperties(_ref, ["className", "color", "viewBox", "dataTest", "children", "ariaHidden", "ariaLabel"]);
  return React.createElement("svg", _extends({}, props, {
    className: className,
    viewBox: viewBox,
    "data-test": dataTest,
    preserveAspectRatio: "xMidYMid meet",
    "aria-hidden": ariaHidden ? 'true' : undefined,
    "aria-label": ariaLabel,
    color: color
  }), children);
};
const StyledIcon = styled(StyledSvg).withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "sc-17nvvtn-0"
})(["width:", ";height:", ";flex-shrink:0;vertical-align:middle;fill:transparent;path{stroke-width:", "px;}"], _ref2 => {
  let {
    width
  } = _ref2;
  return getSize(width);
}, _ref3 => {
  let {
    height
  } = _ref3;
  return getSize(height);
}, _ref4 => {
  let {
    size
  } = _ref4;
  return getStrokeWidth(size);
});
const Icon = props => {
  const {
    size = 24,
    width,
    height,
    color,
    customColor,
    className,
    children,
    viewBox,
    dataTest,
    ariaHidden,
    reverseOnRtl,
    ariaLabel
  } = props;
  return React.createElement(StyledIcon, {
    viewBox: viewBox,
    size: size,
    width: width,
    height: height || size,
    color: color,
    className: className,
    dataTest: dataTest,
    customColor: customColor,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, children);
};
export default Icon;